import { VillageVirtualOfficeLinks } from './../../../../core/services/village-virtual-office-links.service';
//import { ToastService } from './../../../../core/services/toast.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { NgxSpinnerService } from "ngx-spinner";
import { HomeBanner, HomeBannersService } from 'src/app/core/services/home-banners.service';
import { VillageVirtualOfficeLinksService } from 'src/app/core/services/village-virtual-office-links.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/core/services/toast.service';
import { NewsletterService } from 'src/app/core/services/newsletter.service';
import { VillageVideoItems, VillageVideoItemsService } from 'src/app/core/services/village-video-items.service';
import { EventsSettings, EventsSettingsService } from 'src/app/core/services/events-settings.service';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */
  @ViewChild('subscriptionFormRef') subscriptionFormRef!: ElementRef<HTMLFormElement>;
  subscriptionForm: FormGroup = this._fb.group({
    email: [null, [Validators.required, Validators.pattern(/^(([^<>()\[\]\.,;:\s@\']+(\.[^<>()\[\]\.,;:\s@\']+)*)|(\'.+\'))@(([^<>()[\]\.,;:\s@\']+\.)+[^<>()[\]\.,;:\s@\']{2,})$/i)]],
  });


  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    slidesPerGroup: 4,
    speed: 2000,
    spaceBetween: 15,
    // autoplay: {
    //   delay: 6000,
    //   disableOnInteraction: false,
    // },
    keyboard: true,
    loop: false,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    autoplay: false,
    slidesOffsetAfter: 0,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    navigation: {
      nextEl: '.initiatives-button-next',
      prevEl: '.initiatives-button-prev',
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      600: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      991: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4
      },
    },
  };
  homeBannerList!: HomeBanner[];
  villageVirtualOfficeLinksList!: VillageVirtualOfficeLinks[];

  selectedLanguage: string = "en";

  sections = [
    {
      id: "religious_celebrations",
      title: "Religious celebrations"
    }, {
      id: "melas_or_jataras",
      title: "Melas or jataras"
    }
  ];

  villageVideoItems!: VillageVideoItems[];
  eventsSettings!: EventsSettings;

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private _fb: FormBuilder,
    private toast: ToastService,
    private spinner: NgxSpinnerService,
    private homeBannersService: HomeBannersService,
    private route: ActivatedRoute,
    private newsletterService: NewsletterService,
    private villageVideoItemsService: VillageVideoItemsService,
    private eventsSettingsService: EventsSettingsService,
  ) { }

/* ---------------------------- Life Cycle hooks ---------------------------- */

  ngOnInit(): void {
    this.eventsSettingsService.getEventsSettings().subscribe(data=>{
      this.eventsSettings = data;
    })
    this.route.queryParamMap.subscribe(data=>{

      this.selectedLanguage = data.get('lang') ?? 'en';
      console.log( this.selectedLanguage );
    })
    this.homeBannersService.getHomeBanners().subscribe(data=>{
      console.log(data);
      this.homeBannerList = data;
    });
    this.villageVideoItemsService.getVillageVideoItems().subscribe(data=>{
      this.villageVideoItems = data;
    })
    /** spinner starts on init */
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 1000);
  }


  ngAfterViewInit() {
  }


  public onIndexChange(index: number): void {
    console.log('Swiper index: ', index);
  }

  async addNewsLetterSubscription(){
    if(this.subscriptionForm.invalid){
      this.toast.openSnackBar('Please enter valid email address');
      return;
    }
    this.spinner.show();
    try {
      const result = await this.newsletterService.addNewsLetterSubscription(this.subscriptionForm.value).toPromise();
      this.subscriptionFormRef.nativeElement.reset();
      this.spinner.hide();
      this.toast.openSnackBar("You are subscribed to weekly newsletter successfully");
    } catch(error){
      this.spinner.hide();
      this.toast.openSnackBar("You are not subscribed to weekly newsletter. try again");
    }
  }

}
